import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import {
  APP_VARIABLES_PROVIDER_MIDDLEWARE_ROUTE,
  AppVariablesModule,
} from '@tablesready/frontend-variables';

const routes: Route[] = [
  {
    ...APP_VARIABLES_PROVIDER_MIDDLEWARE_ROUTE,
    path: '',
    children: [
      {
        path: 'waitlist',
        loadChildren: () => import(/* webpackChunkName: "public-waitlist-module" */ './waitlist/waitlist.module').then((module) => module.WaitlistModule),
      },
      {
        path: 'check-in',
        loadChildren: () => import(/* webpackChunkName: "public-check-in-module" */ './check-in/check-in.module').then((module) => module.CheckInModule),
      },
      {
        path: 'book',
        loadChildren: () => import(/* webpackChunkName: "public-reservation-module" */ './reservation/reservation.module').then((module) => module.ReservationModule),
      },
    ],
  },
  { path: '**', redirectTo: 'waitlist' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {}), AppVariablesModule],
  exports: [RouterModule],
})
export class AppRouterModule {}
